import ReceiptLink from '../ReceiptLink';
import React, {useId, useRef} from 'react';
import {createPortal} from 'react-dom';
import {useDialogFocus} from './accessibility';
import Icon from './Icon';
import HeadingArt from './HeadingArt';
import {SensitiveValue} from './balanceVisibility';
import {buildTransactionDetail} from './transactionDetailModel';
import './transactionDetail.css';

export default function TransactionDetail({transaction, onClose, hiddenBalances=false}) {
  const dialogRef = useRef(null);
  const headingId = useId();
  const statusId = useId();
  const open = Boolean(transaction);
  useDialogFocus({open, dialogRef, onClose});

  if (!transaction) return null;

  const detail = buildTransactionDetail(transaction);
  const close = () => onClose?.();

  return createPortal(
    <div className="qc-transaction-backdrop" onClick={close}>
      <section
        className="qc-transaction-detail"
        role="dialog"
        aria-modal="true"
        aria-labelledby={headingId}
        aria-describedby={statusId}
        tabIndex={-1}
        ref={dialogRef}
        dir="rtl"
        onClick={event => event.stopPropagation()}
      >
        <header className="qc-transaction-header">
          <HeadingArt name="receipt" size={48}/>
          <div>
            <p>رسید تراکنش</p>
            <h2 id={headingId}>{detail.title}</h2>
          </div>
          <button type="button" className="qc-transaction-close" aria-label="بستن جزئیات تراکنش" data-autofocus onClick={close}>
            <Icon name="close" size={20}/>
          </button>
        </header>

        <div className={`qc-transaction-status is-${detail.status.tone}`} role="status">
          <span>{detail.status.label}</span>
          <p id={statusId}>{detail.status.summary}</p>
        </div>

        <div className="qc-transaction-tracking">
          <span>کد پیگیری</span>
          <b dir="ltr">{detail.trackingCode}</b>
        </div>

        <dl className="qc-transaction-rows">
          {detail.rows.map(row => (
            <div key={row.key} className={row.emphasis ? 'is-emphasis' : undefined}>
              <dt>{row.label}</dt>
              <dd className={row.amount ? 'qc-amount' : undefined}>{row.amount ? <SensitiveValue hidden={hiddenBalances}>{row.value}</SensitiveValue> : row.value}</dd>
            </div>
          ))}
        </dl>

        {detail.description && (
          <div className="qc-transaction-description">
            <h3>توضیح ثبت‌شده</h3>
            <p>{hiddenBalances ? "برای دیدن توضیح مالی، نمایش موجودی‌ها رو روشن کنید." : detail.description}</p>
          </div>
        )}

        <footer className="qc-transaction-actions">
          {detail.receipt && !hiddenBalances && (
            <ReceiptLink href={detail.receipt.href} target="_blank" rel="noreferrer">
              <Icon name="receipt" size={18}/>{detail.receipt.label}
            </ReceiptLink>
          )}
          <button type="button" onClick={close}>بستن</button>
        </footer>
      </section>
    </div>,
    document.body,
  );
}
